import React from 'react';
import { InputLabel, Typography } from '@mui/material';
import clsx from 'clsx';

import css from './Label.module.css';

export interface LabelInputProps {
  htmlFor: string;
  tip?: string;
  children?: React.ReactNode;
  tipClassName?: string;
  className?: string;
}

const Label = ({
  htmlFor,
  tip,
  tipClassName,
  children,
  className
}: LabelInputProps): JSX.Element => (
  <InputLabel className={clsx(css.inputLabel, className)} htmlFor={htmlFor}>
    {children}
    {tip && (
    <Typography component="span" className={clsx(css.tip, tipClassName)}>
      {tip}
    </Typography>
    )}
  </InputLabel>
);

export default Label;
